import { z } from 'zod'

export const ContactsSearchSchema = z.object({
  email: z
    .union([z.string(), z.number()])
    .transform((value) => String(value))
    .optional(),
})

export type ContactsSearch = z.infer<typeof ContactsSearchSchema>
